import axios from 'axios'
import { CountryListResponse } from 'src/models/country.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Fetches the country reference list (labels + per-country address field
 * metadata) from the Addressulator service. The URL is host-relative — the
 * Addressulator base URL comes from the request config, matching the legacy
 * `getCountrys` thunk (`GET /?locale=<locale>` against `ADDRESSULATOR_HOST`).
 */
export const getCountries = async (
  locale: string,
): Promise<CountryListResponse[]> => {
  return getResponseData(
    axios.get<CountryListResponse[]>(
      `/?locale=${locale}`,
      getRequestConfig(RequestConfig.Addressulator),
    ),
  )
}
